angular.module('lf.desktop')

.controller('WishlistCtrl', function ($scope, preloadData, wishlistService, popupsService) {
  var form = {sendMeACopy: false}, emailWishlistPopupName = 'emailWishlist';
  $scope.form = form;
  
  $scope.emailItem = function($event, wishlistItem) {
    $event.preventDefault();
    $scope.wishlistItem = wishlistItem;
    popupsService.show(emailWishlistPopupName);
  };
  
  $scope.emailWishlist = function($event) {
    $event.preventDefault();
    delete $scope.wishlistItem;
    popupsService.show(emailWishlistPopupName);
  };
  
  $scope.submitEmailWishlist = function($event, valid) {
    $event.preventDefault();
    delete $scope.responseData;
    $scope.submitted = true;
    if (!valid) return;
    
    wishlistService.emailWishlist({
      product: $scope.wishlistItem,
      emailTo: form.emailTo,
      emailNote: form.emailNote,
      sendMeACopy: form.sendMeACopy,
    })
    .success(function(data) {
      $scope.responseData = data.data;
      if (data.data.success) {
        popupsService.hide(emailWishlistPopupName);
      }
    });
  };
});
